import "./v2-question-surface.css";

export default function QuestionLabel({ children, id = "question-label" }) {
  return (
    <h1 className="tgc-v2-question-label" id={id}>
      {children}
    </h1>
  );
}
